/** Full-width content area for /admin create, edit, and detail screens */
export const ADMIN_FORM_SHELL_CLASS = 'w-full p-4 md:p-6'

/** Full-width shell for complex admin editors (e.g. course builder) */
export const ADMIN_FORM_SHELL_WIDE_CLASS = 'w-full p-4 md:p-6'
